export const DISABLE_DISTRICTS_AND_SURROUNDINGS_MAP_FOR_REGIONS = [
    33659 // Rzeszów
];
export const DISABLE_DISTRICTS_AND_SURROUNDINGS_MAP_FOR_REGIONS = [
    33659 // Rzeszów
];
